import wretch from 'wretch';

import { ILeadResponseModel } from '@crm-lead/base';

export async function apiGetLead(leadId: number): Promise<ILeadResponseModel> {
  return wretch(`/api/accountmanagement/lead/${leadId}`).get().json();
}
